import React from "react";

const CompletionScreen = ({ subtotal }) => {
  return (
    <div className="text-center py-5">
      <h4>All options selected!</h4>
      <p>Total: ${subtotal.toFixed(2)}</p>
    </div>
  );
};

export default CompletionScreen;
